import React from 'react';
import { howItWorksSteps } from '../data/mock';
import { UserPlus, Sparkles, Link, TrendingUp } from 'lucide-react';

const iconMap = {
  UserPlus,
  Sparkles,
  Link,
  TrendingUp
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            How Crevix Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From sign-up to sales in four simple steps. No tech skills required.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-200 via-emerald-400 to-emerald-200"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorksSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div
                  key={step.step}
                  className="relative group"
                >
                  {/* Step Card */}
                  <div className="bg-white rounded-2xl p-8 border border-slate-100 hover:border-emerald-200 transition-all hover:shadow-xl hover:shadow-emerald-100/50 hover:-translate-y-1">
                    {/* Step Number */}
                    <div className="relative z-10 w-12 h-12 bg-emerald-600 text-white rounded-full flex items-center justify-center text-lg font-bold mb-6 group-hover:scale-110 transition-transform">
                      {step.step}
                    </div>

                    {/* Icon */}
                    <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-emerald-100 transition-colors">
                      {Icon && <Icon className="w-7 h-7 text-emerald-600" />}
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-semibold text-slate-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
